import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import {useNavigate} from 'react-router-dom';
import {ProductSearchProps} from '../../../../types/types';
import AffiliateLink from './affiliateLink';
import {imageSize} from '../../../../styles/theme';

interface BookDetailsProps {
  book: ProductSearchProps;
}

const BookDetails = ({book}: BookDetailsProps) => {
  const {image_url, author_name, ean, title, product_form, price, book_url} =
    book;
  let authorName;
  if (author_name !== '') {
    authorName = <p>{author_name}</p>;
  }

  const navigate = useNavigate();
  const handleGoToBook = () => {
    navigate(`/book?id=${book.id}`, {replace: true});
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        display="flex"
        justifyContent="center"
        alignItems="center">
        <Grid item onClick={handleGoToBook} style={{cursor: 'pointer'}}>
          <img src={image_url} width={imageSize.bookDetail} alt="" />
        </Grid>
        <Grid item xs={10} sm={8}>
          <h3>{title}</h3>
          {authorName}
          <p>
            <b>ISBN-13: </b> {ean}
          </p>
          <p>${price}</p>
          <p>{product_form}</p>
          <Grid>
            <AffiliateLink book_url={book_url} />
          </Grid>
          <Box onClick={handleGoToBook} style={{cursor: 'pointer'}}>
            <b>
              <u>More details</u>
            </b>
          </Box>
        </Grid>
      </Grid>
      <Grid item height="15px" />
    </>
  );
};

export default BookDetails;
